var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { apiFetch } from "../../lib/api/client";
import { API_ENDPOINTS } from "../../lib/api/endpoints";
import { normalizeChartApiResponse } from "../../utils/displayText";
var hasSelectedFilterValues = function (value) {
    return Array.isArray(value) ? value.length > 0 : Boolean(value);
};
var FriendlyAssistantError = /** @class */ (function (_super) {
    __extends(FriendlyAssistantError, _super);
    function FriendlyAssistantError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.name = "FriendlyAssistantError";
        _this.code = code;
        return _this;
    }
    return FriendlyAssistantError;
}(Error));
export { FriendlyAssistantError };
export var normalizeQuery = function (query) {
    return query
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
};
export var SUPPORTED_ASSISTANT_SUGGESTIONS = [
    "Local da ocorrência de violência",
    "Canal utilizado para registro das denúncias",
    "Distribuição por gênero das vítimas",
];
export var ASSISTANT_MENU_THEMES = [
    {
        id: "vitimas",
        label: "Vítimas",
        options: [
            {
                label: "Distribuição por gênero das vítimas",
                query: "Distribuição por gênero das vítimas",
            },
            {
                label: "Distribuição etária das vítimas",
                query: "perfil etário da vítima",
            },
            {
                label: "Presença de deficiência entre as vítimas",
                query: "Presença de deficiência entre as vítimas",
            },
        ],
    },
    {
        id: "ocorrencias",
        label: "Ocorrências",
        options: [
            {
                label: "Local da ocorrência de violência",
                query: "Local da ocorrência de violência",
            },
            {
                label: "Local de ocorrência da violação",
                query: "Local de ocorrência da violação",
            },
            {
                label: "Municípios com maior número de casos reportados",
                query: "municípios com maior número de vitimas",
            },
        ],
    },
    {
        id: "denuncias",
        label: "Denúncias",
        options: [
            {
                label: "Canal utilizado para registro das denúncias",
                query: "Canal utilizado para registro das denúncias",
            },
            {
                label: "Origem da denúncia",
                query: "origem dos casos reportados",
            },
            {
                label: "Ano com maior número de denúncias",
                query: "Ano com maior número de denúncias",
            },
        ],
    },
];
var FIXED_QUERIES = new Set(__spreadArray([
    "ano com maior número de denúncias",
    "ano com maior numero de denuncias",
    "ano com maior número de vítimas",
    "ano com maior número de violações",
    "ano com menor número de violações",
    "grupo mais atingido em denúncias",
    "grupo menos atingido em denúncias",
    "grupo mais atingido com denuncias",
    "grupo menos atingido com denuncias",
    "grupo mais atingido com vítimas",
    "grupo menos atingido com vítimas",
    "grupo mais atingido com violações",
    "grupo menos atingido com violações",
    "linha temporal de vítimas por grupo vulnerável",
    "linha temporal de denuncias por grupo vulneravel",
    "linha temporal de violações por grupo vulnerável",
    "vítimas registradas por grupo vulnerável atingido por ano",
    "denuncias registradas por grupo vulneravel atingido por ano",
    "violações registradas por grupo vulnerável atingido por ano",
    "total de denuncias no periodo",
    "ranking de denuncias por grupo no periodo",
    "distribuicao percentual de denuncias por grupo no periodo",
    "total de vítimas no período",
    "ranking de vítimas por grupo no período",
    "distribuição percentual de vítimas por grupo no período",
    "total de violações no período",
    "ranking de violações por grupo no período",
    "distribuição percentual de violações por grupo no período",
    "denúncias de crime",
    "ocupações mais registradas entre as vítimas",
    "naturezas de mvis",
    "registros por natureza de ocorrência",
    "meio empregado para mvis",
    "municípios com maior número de vitimas",
    "local de ocorrência da violação",
    "nível de escolaridade das vítimas",
    "canal utilizado para registro dos casos reportados",
    "origem dos casos reportados",
    "total de feminicídios históricos",
    "evolução anual de feminicídios",
    "distribuição histórica por raça/cor",
    "distribuição histórica por vínculo autor-vítima",
    "casos recentes por mês",
    "distribuição recente por natureza",
    "evolução anual de bos",
    "evolução mensal de bos",
    "série mensal de deams",
    "distribuição do número de vitimas por grupo vulnerável",
    "distribuição por gênero das vítimas",
    "orientação sexual das vítimas",
    "presença de deficiência entre as vítimas",
    "estado civil da vítima",
    "perfil etário da vítima",
    "perfil racial da vítima",
    "quantidade de vítimas por grau de instrução",
    "bos com motivação homofobia",
    "dinâmica temporal do crime",
    "por faixa etária e perfil racial",
    "análise bivariada da cor da pele e faixa etária",
    "análise bivariada crimes e motivação",
    "cor da pele das vítimas (exceto mvis)",
    "cor da pele das vítimas (mvis)",
    "escolaridade das vítimas (exceto mvis)",
    "faixa etária das vítimas de mvis",
    "frequência absoluta das faixas etárias das vítimas (exceto mvis)",
    "frequência absoluta dos grupos de natureza (exceto mvis)",
    "tipo de local das mvis",
    "tipo de local (exceto mvis)",
    "definição de naturezas criminais registradas",
    "motivações de crimes",
    "instrumentos utilizados nas mvis",
    "ocupação das vítimas (exceto mvis)",
    "análise bivariada grupos de crime e faixa etária",
    "horário das ocorrências criminais mvis"
], SUPPORTED_ASSISTANT_SUGGESTIONS, true).map(normalizeQuery));
export var isFixedQuery = function (query) {
    return FIXED_QUERIES.has(normalizeQuery(query));
};
var mapAssistantError = function (rawMessage) {
    var normalizedMessage = normalizeQuery(rawMessage || "");
    if (normalizedMessage.includes("guardrail") ||
        normalizedMessage.includes("fora do escopo") ||
        normalizedMessage.includes("nao permitido") ||
        normalizedMessage.includes("não permitido") ||
        normalizedMessage.includes("nao autoriz") ||
        normalizedMessage.includes("não autoriz") ||
        normalizedMessage.includes("pasted")) {
        return new FriendlyAssistantError("blocked", "Não consegui atender esse pedido com segurança. Posso sugerir algumas opções de gráfico para você continuar.");
    }
    if (normalizedMessage.includes("sem dados") ||
        normalizedMessage.includes("dados suficientes") ||
        normalizedMessage.includes("dataset") ||
        normalizedMessage.includes("vazio")) {
        return new FriendlyAssistantError("no_data", "Não encontrei dados suficientes para montar esse gráfico. Posso te mostrar algumas opções relacionadas.");
    }
    return new FriendlyAssistantError("unexpected", "Não consegui criar esse gráfico agora. Tente reformular o pedido ou escolha uma das opções sugeridas.");
};
export function fetchChartData(question, options) {
    var _a, _b, _c, _d, _e, _f;
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, Promise, function () {
        var trimmedQuestion, shouldUseFixedQuery, hasFilters, endpoint, payload, response, error_1, message;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    trimmedQuestion = question.trim();
                    if (!trimmedQuestion) {
                        throw new FriendlyAssistantError("unexpected", "Escreva o que você gostaria de visualizar ou escolha uma das opções sugeridas.");
                    }
                    shouldUseFixedQuery = isFixedQuery(trimmedQuestion);
                    hasFilters = hasSelectedFilterValues(options.yearFilter) ||
                        hasSelectedFilterValues(options.semesterFilter) ||
                        Boolean(options.customFilters && Object.keys(options.customFilters).length > 0);
                    endpoint = shouldUseFixedQuery && !hasFilters
                        ? API_ENDPOINTS.fixedQuery
                        : API_ENDPOINTS.agent;
                    payload = {
                        query: trimmedQuestion,
                    };
                    if (hasSelectedFilterValues(options.yearFilter)) {
                        payload.year_filter = options.yearFilter;
                    }
                    if (hasSelectedFilterValues(options.semesterFilter)) {
                        payload.semester_filter = options.semesterFilter;
                    }
                    if (options.customFilters && Object.keys(options.customFilters).length > 0) {
                        payload.custom_filters = options.customFilters;
                    }
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiFetch(endpoint, {
                            method: "POST",
                            body: payload,
                            timeout: 180000,
                        })];
                case 2:
                    response = _g.sent();
                    if ("guardrails" in response && response.guardrails) {
                        throw mapAssistantError(response.guardrails);
                    }
                    if (!("success" in response) || !response.success) {
                        throw mapAssistantError(("message" in response && response.message) ||
                            "Não foi possível obter os dados para a sua pergunta, tente novamente mais tarde.");
                    }
                    if (!((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.length)) {
                        throw mapAssistantError("dados suficientes");
                    }
                    return [2 /*return*/, normalizeChartApiResponse(response)];
                case 3:
                    error_1 = _g.sent();
                    if (error_1 instanceof FriendlyAssistantError) {
                        throw error_1;
                    }
                    message = ((_d = (_c = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.guardrails) ||
                        ((_f = (_e = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) ||
                        (error_1 === null || error_1 === void 0 ? void 0 : error_1.message);
                    throw mapAssistantError(message);
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function fetchChartDataCached(question, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchChartData(question, options)];
        });
    });
}
export function clearAllChartCache() {
    return __awaiter(this, void 0, Promise, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiFetch(API_ENDPOINTS.cache, {
                            method: "DELETE",
                            timeout: 15000,
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
